import { render, staticRenderFns } from "./editFeatureBi.vue?vue&type=template&id=344bb027&scoped=true"
import script from "./editFeatureBi.vue?vue&type=script&lang=js"
export * from "./editFeatureBi.vue?vue&type=script&lang=js"
import style0 from "./editFeatureBi.vue?vue&type=style&index=0&id=344bb027&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344bb027",
  null
  
)

export default component.exports